import styles from '../EligibilityModal.module.scss';
import XCloseIcon from 'components/icons/XCloseIcon';

interface CloseButtonProps {
  onClose: () => void;
}

export default function CloseButton({ onClose }: CloseButtonProps) {
  return (
    <button
      onClick={onClose}
      className={styles.closeButton}
      aria-label="Close modal"
    >
      <XCloseIcon />
    </button>
  );
}
